import React, { useEffect, useState } from "react";
import { formatPrice } from "../../utils/formatPrice";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/actions/CartActions";
import pricing from "../../assets/data/pricing.json";
import Swal from "sweetalert2";
import { updateBusinessRequest } from "../../redux/actions/RequestActions";
import Loader from "../../components/loader/Loader";
import typesEntreprises from "../../assets/data/typesEntreprises.json";

function EditBusinessType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const { businessCreationRequest } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleAddToCart = async (value) => {
    if (cart.from === "creation") {
      await dispatch(
        addToCart({
          creation: { businessType: value, amount: pricing.creation[value] },
        }),
      );
    } else {
    }

    const selectedType = typesEntreprises.find((type) => type.name === value);
    if (
      selectedType &&
      selectedType.canCreateWithPartners &&
      cart.from === "creation"
    ) {
      await dispatch(
        addToCart({
          businessType: value,
        }),
      );
      navigate(`/associated-creators-2`);
    } else {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            businessType: selectedType,
          },
          (response) => handleCallback(response, value),
        ),
      );
    }
  };

  const handleCallback = async ({ success, message }, value) => {
    const selectedType = typesEntreprises.find(
      (typeEntreprise) => typeEntreprise.name === value,
    );
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          businessType: value,
        }),
      );
      if (
        selectedType &&
        selectedType.canCreateWithPartners &&
        cart.from === "creation"
      ) {
        navigate(`/associated-creators`);
      } else {
        navigate(-1, { replace: true });
      }
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        <div className="container my-4">
          {cart.from === "creation" && (
            <h4 className="text-center mt-4 mb-4">
              Quel <span style={{ color: "#FF5500" }}>type</span> d'entreprise
              souhaitez-vous créer ?
            </h4>
          )}
          {cart.from === "domiciliation" && (
            <h4 className="text-center  mt-4 mb-4">
              Quel <span style={{ color: "#FF5500" }}>type</span> d'entreprise
              souhaitez-vous domicilier ?
            </h4>
          )}
          {cart.from === "management" && (
            <h4 className="text-center  mt-4 mb-4">
              Quel <span style={{ color: "#FF5500" }}>type</span> d'entreprise
              souhaitez-vous gérer ?
            </h4>
          )}
          <Row className="justify-content-center">
            {typesEntreprises.map((type, index) => (
              <Col
                xs={12}
                sm={4}
                md={3}
                lg={3}
                key={index}
                className="mb-4 mx-3"
              >
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id={`tooltip-${index}`}>
                      {type.description}
                    </Tooltip>
                  }
                >
                  <Card
                    style={{
                      height: "100px",
                      cursor: "pointer",
                      transition: "0.3s",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      textAlign: "center",
                      border: "2px solid transparent",
                    }}
                    className="p-2"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 8px 16px rgba(0, 0, 0, 0.2)";
                      e.currentTarget.style.borderColor = "#FF5500";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 4px 8px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.borderColor = "transparent";
                    }}
                    onClick={() => handleAddToCart(type.name)}
                  >
                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                      <Card.Title style={{ fontSize: "1rem", fontWeight: 500 }}>
                        {type.name}
                      </Card.Title>
                      {cart.from === "creation" && (
                        <span
                          style={{
                            fontSize: "1rem",
                            borderRadius: "5px",
                            color: "#FF5500",
                          }}
                        >
                          {formatPrice(pricing.creation[type.name])}
                        </span>
                      )}
                    </Card.Body>
                  </Card>
                </OverlayTrigger>
              </Col>
            ))}
          </Row>
        </div>
      </>
    </div>
  );
}

export default EditBusinessType;
